export const links = {
  baseURL: 'https://api.salloumconstruction.com/',
  uploads: 'https://api.salloumconstruction.com/uploads/',

  // baseURL: 'http://192.168.1.7:3001',
  // uploads: 'http://192.168.1.7:3001/uploads/',
  home: {
    slideshow: 'slideshow',
    service: 'service',
    settings: 'setting/65de4f50e362d71f317f96eb',
    product: 'product',
    client: 'client',
    brand: 'brand',
    news: 'news',
    productsearch: 'productsearch',
    category: 'productcategory',
    photoGallery: 'photoGallery',
  },
  contact: 'contact',
};
